<template>
  <div class="l-edit-dialog-box">
    <el-form :model="form_data" label-width="150px" ref="form" :rules="rules" label-position="left" v-loading="loading">
      <!-- <el-form-item label="上级组织" prop="pid">
        <el-cascader v-model="form_data.pid" :options="tree_node" :props="{ checkStrictly: true }" clearable></el-cascader>
      </el-form-item> -->
      <el-form-item label="组织类型" prop="type" v-if="!this.hasId">
        <!-- <el-form-item label="组织类型" prop="type" v-if="!hasId"></el-form-item> -->
        <el-radio-group v-model="form_data.type">
          <el-radio :label="2"  @change="changes" v-if="typeS < 2" >公司</el-radio>
          <el-radio :label="3"  @change="changes" v-if="typeS < 3 " >部门</el-radio>
          <el-radio :label="4"  @change="changes" v-if="typeS < 4 " >小组</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- <el-form-item label="归属公司" prop="depart_ids" v-if="form_data.type == 3 || form_data.type == 4 ">
        <el-select v-model="form_data.depart_ids" multiple placeholder="请选择部门(可多选)" clearable @change="changes"
          :disabled="depart_list.length == 0">
          <el-option v-for="item in depart_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
        </el-select>
      </el-form-item> -->

      <el-form-item label="上级权限" prop="pid" v-if="!this.hasId">
        <el-cascader  disabled="true" v-model="form_data.pid" :options="treeNode" :props="{ checkStrictly: true }" clearable></el-cascader>
      </el-form-item>

      <el-form-item label="组织名称" prop="name">
        <el-input v-model="form_data.name" autocomplete="off" placeholder="请输入名称"></el-input>
      </el-form-item>
      <!-- <el-form-item label="公司简称" prop="short_name" v-if="form_data.type == 1">
        <el-input v-model="form_data.short_name" autocomplete="off" placeholder="请输入公司简称"></el-input>
      </el-form-item> -->
      <el-form-item label="管理app" prop="app_ids" v-if="!this.hasId">
        <el-select v-model="form_data.app_ids" multiple placeholder="请选app(可多选)" clearable 
          :disabled="app_list.length == 0">
          <el-option v-for="item in app_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
        </el-select>
      </el-form-item>

      <!-- <el-form-item label="管理小组" prop="group_ids" v-if="form_data.type == 1 || form_data.type == 2">
        <el-select v-model="form_data.group_ids" placeholder="请选择小组(可多选)" multiple
          :disabled="group_list.length == 0">
          <el-option v-for="item in group_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
        </el-select>
      </el-form-item> -->

    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "l-org-edit",
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    pid: {
      type: [Number, String],
      default: "",
    },
    org_type: {
      type: [Number, String],
      default: "",
    },

    visible: {
      type: Boolean,
    },
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
  },
  data() {
    return {
      typeS :10,
      loading: false,
      treeNode: [],
      app_list: [],
      //表单数据
      submitting: false,
      form_data: {
        pid: [],
        name: "",
        type: '',
        app_ids: [],
        short_name: '',
      },

      p_info: {},

      rules: {
        pid: [
          {
            required: true,
            message: "请选择上级组织",
            trigger: "change",
          },
        ],
        type: [
          {
            type: "number",
            required: true,
            message: "请选择组织类型",
            trigger: "change",
          },
        ],
        name: [
          { required: true, message: "请输入组织名称", trigger: "change" },
        ],

        app_ids: [
          { required: true, message: "请选择app", trigger: "change" },
        ],
      },
    };
  },

  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form_data.pid = this.$props.pid;
       
          this.form_data.type = this.$props.org_type + 1;
          this.typeS = this.$props.org_type;
          // console.log(this.$props.org_type);
          this.getData();
          this.changes();
          
        }
      },
    },
  },

  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit("update:visible", false);
    },
    //点击获取社区
    changes() {
      this.$_invoke("org_getAddData", {
        type: this.form_data.type,
        pid: this.$props.pid
      }).then((ret) => {
        // console.log(ret)
        this.treeNode = ret.treeNode;
      })
        .finally(() => {
          this.loading = false;
        });
    },

    //获取添加数据
    getData() {

      if (this.hasId) {
        this.loading = true;
        //编辑获取数据
        this.$_invoke("org_getEditData", { id: this.$props.id })
          .then((ret) => {
            let { tree_node, list, data, is_company } = ret;
            this.tree_node = tree_node;
            this.module_list = ret.module_list;
            this.$nextTick(() => {
              if (!is_company) {
                //找到pid所属的路径
                const curr_p_data = list.find((item) => {
                  return item.id == data.pid;
                });
                // console.log(curr_p_data);
                let p_path_arr = curr_p_data.path.split(">");
                p_path_arr = p_path_arr.filter((item) => {
                  return item != "";
                });
                p_path_arr.push(data.pid);
                p_path_arr = p_path_arr.map((item) => {
                  return parseInt(item);
                });
                p_path_arr.splice(0, 1);
                data.pid = p_path_arr;
              } else {
                data.pid = [data.pid];
              }

              this.form_data = data;
            });
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$_invoke("org_getAddData", {
          type: this.form_data.type,
          pid: this.$props.pid
        })
          .then((ret) => {
            // console.log(ret)
            this.app_list = ret.app_list;
            this.treeNode = ret.treeNode;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log(this.form_data);
          this.submitting = true;
          this.form_data.pid = this.$props.pid;
          if (!this.hasId) {
            //添加
            this.$_invoke("org_save", this.form_data)
              .then(() => {
                this.$_msg.success("添加成功");
                this.$emit("on-success");
              })
              .finally(() => {
                this.submitting = false;
              });
          } else {
            //修改
            this.$_invoke(`org_update`, this.form_data)
              .then(() => {
                this.$_msg.success("修改成功");
                this.$emit("on-success");
              })
              .finally(() => {
                this.submitting = false;
              });
          }
        }
      });
    },
  },
};
</script>
